import { useNavigate } from "react-router-dom";


const Footer = () => {
  const navigate = useNavigate();

  const privacy = () => {
    navigate("/privacy-policy");
  };

  const aboutUs=()=>{
    navigate("/about")
  }

  const contactUs=()=>{
    //navigate("/about", { state: { isModalOpen: true } })
    navigate("/contact-us")
  }

  

  return (
  <footer className="footer" style={{background:"#5c3320",color:"#ffffff"}}>
    © 2025 ChessWizzania
   <span className="adsense" onClick={privacy}> 
     Privacy Policy</span>
   <span className="adsense" onClick={aboutUs}>
     About Us</span>
   <span className="adsense" onClick={contactUs}>
     Contact Us</span>
    </footer>
    )
};

export default Footer;
